import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { BtnComponent } from '../../components/button';
import { InputField } from '../../components/reactHookFormFields/inputField';
import { forgotPassword } from '../../services/login';
import ethizologo from "../../assets/images/logo-login.svg";
import { setBaseUrl } from '../../helpers/utility';

const ForgetPassword = () => {

    const navigate = useNavigate();
    const[isSubmitting, setIsSubmitting] = useState(false);
    const[displayMsg, setDisplayMsg] = useState('');

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {},
    });


    const handleSubmitForm = (values) => {

        setBaseUrl(values?.practice_code ? values?.practice_code?.trim()?.toLowerCase() : '');
        setIsSubmitting(true);
        forgotPassword({...values}).then((res) => {
            setIsSubmitting(false);
            if(res?.data?.response.code == 0){
                setDisplayMsg(res?.data?.response?.data);
            }
            else {
                toast.error(res?.data?.response?.msg);
            }
        });
    };


    return (
        <div className='min-h-screen'>
            <div className="flex justify-center items-center pt-4 md:pt-[5rem] py-4">
                <img src={ethizologo} alt="logo" className="w-40"></img>
            </div>
            <div className='w-4/5 md:w-2/3 mx-auto  mt-4 login-container'>
                {displayMsg ?   
                    <div className='flex flex-col justify-center gap-4 mb-3'>
                        <h3 className='text-2xl font-medium leading-9 tracking-tight text-gray-900'>Check your email</h3>
                        <p>We've sent an email to <strong>{displayMsg}</strong>. Click the link in the email to reset your password.</p>
                        <p>If you don't see the email, check other places it might be, like your junk, spam, social or other folders.</p>
                        <p>If you didn't receive the email then contact your facility provider.</p>
                    </div>
                    :
                    <div className="flex flex-col md:flex-row items-start gap-4 justify-center ">
                        <div className=" flex-1 w-full h-[20.7rem] md:h-[21.7rem]">
                            <div className="flex min-h-full flex-col lg:px-8">
                                <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                                    <h2 className="text-start text-2xl font-medium leading-9 tracking-tight text-gray-900">Find your careco account</h2>
                                    <form className="space-y-6" name="forget_password_form" onSubmit={handleSubmit(handleSubmitForm)}>
                                        <div className="mt-2">
                                            <InputField
                                                title="Email or Username"
                                                name="email"
                                                control={control}
                                                rules={{
                                                    required: {
                                                        value: true,
                                                        // message: "Please enter ",
                                                    },
                                                }}
                                                errors={errors}
                                            />
                                        </div>
                                        <div className="mt-2">
                                            <InputField
                                                title="Organization Code"
                                                name="practice_code"
                                                control={control}
                                            />
                                        </div>
                                        <BtnComponent btnType='primary' type="submit" className="flex w-full justify-center px-3 py-2 text-lg font-bold border border-ethizo_primary rounded-md bg-ethizo_primary text-[14px] text-white hover:bg-primary-hover hover:border-primary-hover" loading={isSubmitting} text="Submit" />
                                        <p className='text-sm'>If you do not remember your username and email, please contact your facility admin.</p>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div className="flex justify-center py-2 bg-slate-500  rounded-lg rounded-t-none">
                    <div className="text-center">
                        <a href="/auth/login" className="text-white hover:underline">
                            Login
                        </a>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ForgetPassword;
